import styled from 'styled-components';

export const Container = styled.section`
  padding-top: 80px;
  padding-bottom: 130px;
  margin-top: -32px;
  border-radius: 32px 32px 0 0;

  .questions {
  }

  .swiper-container {
    overflow: visible;
  }
`;

export default Container;
